export const generateFsPlaceholders = (payload: string) => {
  const variables = JSON.parse(payload);
  if (!variables || !variables.length) return {};

  const result: Record<string, string> = {};
  for (const fsVar of variables) {
    result[fsVar.name] = `{{${fsVar.name}}}`;
  }
  return result;
};
